  $(document).ready(function() {
  $('.product-features-main-wrp .accordion-titles').on('click', function() {
      if($(this).hasClass('active')){
          $(this).removeClass('active');
          $(this).siblings('.accordion-content').slideUp();
      }
      else{
          $(this).addClass('active');
          $(this).siblings('.accordion-content').slideDown();
      }
  });
});
